import { useContext, useEffect } from 'react';
import DashboardTable from './DashboardTable';
import Context from '../context/Context';


const Dashboard = () => {
  const { setPageTitle } = useContext(Context);

  useEffect(() => {
    setPageTitle('Dashboard');
  }, [setPageTitle]);
  return (
    <>
      <div className='px-3'>
        <DashboardTable />
      </div>
    </>
  )
}

export default Dashboard
